import { useCallback } from 'react'

export default function useMediaHandling({ processFiles, showNotification, pendingMedia, updatePendingMedia }) {
  const handleFilesAdded = (files) => {
    processFiles(
      files,
      () => {},
      (processedFiles) => {
        const updated = [...pendingMedia, ...processedFiles]
        updatePendingMedia(updated)
      },
      (errorMessage, fileName) => {
        showNotification(`Error processing file ${fileName || ''}: ${errorMessage}`, 'error')
      }
    )
  }

  const handleEmbedAdded = (embedData) => {
    const updated = [...pendingMedia, embedData]
    updatePendingMedia(updated)
  }

  const handleRemoveMedia = (mediaId) => {
    const updated = pendingMedia.filter((media) => media.id !== mediaId)
    updatePendingMedia(updated)
  }

  const handleReorderMedia = useCallback((reorderedMedia) => {
    updatePendingMedia(reorderedMedia)
  }, [updatePendingMedia])

  const clearPendingMedia = () => {
    updatePendingMedia([])
  }

  return {
    handleFilesAdded,
    handleEmbedAdded,
    handleRemoveMedia,
    handleReorderMedia,
    clearPendingMedia,
  }
}
